// @mui
import {useTheme} from '@mui/material/styles';
import {GlobalStyles} from '@mui/material';


export default function AppGlobalStyles() {
    const theme = useTheme();

    return (
        <GlobalStyles
            styles={{
                '*': {
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box'
                },
                html: {
                    width: '100%',
                    height: '100%',
                    WebkitOverflowScrolling: 'touch',
                },
                body: {
                    width: '100%',
                    height: '100%',
                    fontFamily: "Inter Variable, sans-serif"
                },
                '#root': {
                    width: '100%',
                    height: '100%'
                },
                input: {
                    '&[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none'
                        },
                        '&::-webkit-inner-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none'
                        }
                    }
                },
                textarea: {
                    '&::-webkit-input-placeholder': {
                        color: theme.palette.text.disabled
                    },
                    '&::-moz-placeholder': {
                        opacity: 1,
                        color: theme.palette.text.disabled
                    },
                    '&:-ms-input-placeholder': {
                        color: theme.palette.text.disabled
                    },
                    '&::placeholder': {
                        color: theme.palette.text.disabled
                    }
                },
                img: {display: 'block', maxWidth: '100%'},
                '.ProseMirror ol, .ProseMirror ul, .lm-comment-list ol, .lm-comment-list ul': {
                    marginLeft: theme.spacing(3)
                }
            }}
        />
    );
}
